import { render, staticRenderFns } from "./customer-view.vue?vue&type=template&id=aa3faeca&scoped=true&"
import script from "./customer-view.vue?vue&type=script&lang=ts&"
export * from "./customer-view.vue?vue&type=script&lang=ts&"
import style0 from "./customer-view.vue?vue&type=style&index=0&id=aa3faeca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa3faeca",
  null
  
)

export default component.exports